const T_PREFIX = "settings";

export const settignsTrns = {
  countryOfRegistration: `${T_PREFIX}.titles.country-of-registration`,
  companyInfo: `${T_PREFIX}.titles.company-info`,
  responsiblePerson: `${T_PREFIX}.titles.responsible-person`,
  briefInfo: `${T_PREFIX}.titles.brief-info`,
  chooseIndustry: `${T_PREFIX}.titles.choose-industry`,
  internationalMarket: `${T_PREFIX}.titles.international-market`,
  countriesOfRepresentation: `${T_PREFIX}.titles.countries-of-representation`,
  uploadFoundingDocuments: `${T_PREFIX}.titles.upload-founding-documents`,
  loggingInData: `${T_PREFIX}.titles.logging-in-data`,
  submitButton: `${T_PREFIX}.submit-btn`,
};

export const settignsSubtitlesTrns = {
  internationalMarket: `${T_PREFIX}.subtitles.international-market`,
};
